import Telemetry from '@atlassian/mpac-telemetry';
export const ViewHomeEnterpriseSection = Telemetry.createGenericTask('view-home-enterprise-section');
export const ViewHomeSections = Telemetry.createGenericTask('view-home-sections');
export const HomePageTask = Telemetry.createPageViewTask('view-home-page').dependsOn([ViewHomeEnterpriseSection, ViewHomeSections]);
export const ViewProductEnterpriseSection = Telemetry.createGenericTask('view-product-enterprise-section');
export const ViewProductSections = Telemetry.createGenericTask('view-product-sections');
export const setupProductHomepageTask = isEnterpriseSectionVisible => {
  if (isEnterpriseSectionVisible) {
    return Telemetry.createPageViewTask('view-product-page').dependsOn([ViewProductSections, ViewProductEnterpriseSection]);
  } else {
    return Telemetry.createPageViewTask('view-product-page').dependsOn([ViewProductSections]);
  }
};